"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FerryIcon = FerryIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function FerryIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M 16 0 C 7.18 0 0 7.18 0 16 C 0 24.82 7.18 32 16 32 C 24.82 32 32 24.82 32 16 C 32 7.18 24.82 0 16 0 Z M 16 30.56 C 7.97 30.56 1.44 24.03 1.44 16 C 1.44 7.97 7.97 1.44 16 1.44 C 24.03 1.44 30.56 7.97 30.56 16 C 30.56 24.03 24.03 30.56 16 30.56 Z M 23.28 23.43 L 19.64 25.69 L 16 23.43 L 12.36 25.69 L 8.72 23.43 L 4.63 25.97 L 5.53 27.41 L 8.72 25.43 L 12.36 27.69 L 16 25.43 L 19.64 27.69 L 23.28 25.43 L 26.47 27.41 L 27.37 25.97 Z M 8.72 19 L 8.72 21.51 L 12.36 23.77 L 16 21.51 L 19.64 23.77 L 23.28 21.51 L 23.28 19 L 26.15 14.87 L 23.44 13.24 L 22.8 6.44 C 22.74 5.82 22.18 5.31 21.56 5.31 L 10.45 5.31 C 9.83 5.31 9.27 5.82 9.21 6.44 L 8.57 13.24 L 5.86 14.87 L 8.73 19 Z M 10.85 7 L 21.15 7 L 21.63 12.15 L 16 8.76 L 10.37 12.15 L 10.85 7 Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1"
  }));
}